<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1 sigil_not_in_toc">Vier Monate russische Kriegsgefangenschaft</h1>
<p class="calibre2"></p>
<p class="calibre2"></p>
<h2 class="title" id="calibre_pb_0">Nach Sibirien mit hunderttausend Deutschen</h2>
<p class="calibre2"></p>
<h4 class="subtitle sigil_not_in_toc">Vier Monate russische Kriegsgefangenschaft</h4>
<p class="calibre2"></p>
<p class="calibre2"><br/></p>
<p class="calibre2"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0_split_000.vue?9ef33bb4